import React from 'react'
import PropTypes from 'prop-types'

const CellStatusData = {
  pending: {
    label: 'Aguardando',
    className: 'text-muted',
  },
  'in-review': {
    label: 'Analisando',
    className: 'text-info',
  },
  allowed: {
    label: 'Acesso permitido',
    className: 'text-success',
  },
  'not-allowed': {
    label: 'Recusado',
    className: 'text-danger',
  },
};

const CellStatus = ({value}) => {
  const data = CellStatusData[value] || CellStatusData.pending;
  return <strong className={data.className}>{data.label}</strong>;
};

CellStatus.propTypes = {
  //label: PropTypes.string,
};

const styles = {};

export default CellStatus;



// WEBPACK FOOTER //
// ./src/components/CellStatus.js